import { render } from "./News24.vue?vue&type=template&id=d3d320c2"
import script from "./News24.vue?vue&type=script&lang=js"
export * from "./News24.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__